<div class="tab-label">
  <div [matTooltip]="name" [matBadge]="alerts" matBadgePosition="above after" matBadgeColor="accent" matBadgeSize="medium">
    <img [src]="src">
  </div>
</div>
